import React from 'react';
import { Icon, Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import Modal from 'PointOfSale/modules/common/component/Modal';
import SessionHeader from 'PointOfSale/modules/servingOptions/component/SessionHeader';
import ContinueButton from 'PointOfSale/modules/servingOptions/component/ContinueButton';
import ServingOptionSubMenu from 'PointOfSale/modules/servingOptionCategory/container';
import SessionChips from 'PointOfSale/modules/servingOptions/component/SessionChips';

const AddSessionModalComponent = props => {
  const {
    open,
    sessions,
    activeSession,
    currentSession,
    currentSelectedSession,
    selectedPageIndex,
    goToStartingPage,
    handleBack,
    handleStartServing,
    queueButtonClick,
    groupButtonClick,
    teacherButtonClick,
    otherItemButtonClick,
    onClose,
  } = props;

  const header = (
    <SessionHeader
      currentSelectedSession={currentSelectedSession}
      onClose={onClose}
    />
  );
  const servingOptionSubMenu =
    selectedPageIndex === 2 ? (
      <Grid key="grid" className="gridClass">
        <ServingOptionSubMenu
          currentSelectedMenu={currentSelectedSession}
          columns={2}
          gridColumnClassName={'margin0'}
        />
      </Grid>
    ) : null;
  const disableBackBtn = selectedPageIndex === 1;
  const actions = [
    <ContinueButton
      key="continue"
      currentSelectedSession={currentSelectedSession}
      currentSession={currentSession}
      selectedPageIndex={selectedPageIndex}
      handleBack={handleBack}
      handleStartServing={handleStartServing}
    />,
  ];

  return (
    <Modal
      key="sessionModal"
      open={open}
      size={'tiny'}
      onClose={onClose}
      header={header}
      actions={actions}
      actionClassName="modal-action"
    >
      <div
        onClick={disableBackBtn ? null : goToStartingPage}
        className="cursorPointer backBtn"
        style={{ width: '100%' }}
      >
        <Icon name={'angle left'} size={'big'} disabled={disableBackBtn} />
      </div>
      {selectedPageIndex === 1 ? (
        <SessionChips
          key="sessionKey"
          sessions={sessions}
          activeSession={activeSession}
          queueButtonClick={queueButtonClick}
          groupButtonClick={groupButtonClick}
          teacherButtonClick={teacherButtonClick}
          otherItemButtonClick={otherItemButtonClick}
          currentSelectedSession={currentSelectedSession}
        />
      ) : (
        servingOptionSubMenu
      )}
    </Modal>
  );
};

AddSessionModalComponent.propTypes = {
  open: PropTypes.bool,
  sessions: PropTypes.object,
  activeSession: PropTypes.string,
  currentSession: PropTypes.object,
  currentSelectedSession: PropTypes.string,
  selectedPageIndex: PropTypes.number,
  goToStartingPage: PropTypes.func,
  handleBack: PropTypes.func,
  handleStartServing: PropTypes.func,
  queueButtonClick: PropTypes.func,
  groupButtonClick: PropTypes.func,
  teacherButtonClick: PropTypes.func,
  otherItemButtonClick: PropTypes.func,
  onClose: PropTypes.func,
};

export default AddSessionModalComponent;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/servingOptions/component/AddSessionModal.js